import { useState } from 'react';
import { faqs } from '@/mocks/home';
import Reveal from '@/components/base/Reveal';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-[0.75fr_1.25fr] lg:gap-14">
        <div>
          <span className="text-xs font-medium tracking-[0.2em] text-primary-600">FAQ</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            常见疑问
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            开始阅读前，先看看大家问得最多的几个问题，能帮你更快抓住海角黑料事件的重点。
          </p>
          <div className="mt-6 flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-50 text-primary-600">
              <i className="ri-lightbulb-line text-lg" />
            </span>
            <p className="text-xs leading-relaxed text-foreground-600">
              内容为公开信息整理，若有出入请以原始表述为准。
            </p>
          </div>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <Reveal key={faq.q} delay={index * 60}>
                <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                      {faq.q}
                    </span>
                    <i
                      className={`shrink-0 text-lg text-primary-500 ${
                        isOpen ? 'ri-subtract-line' : 'ri-add-line'
                      }`}
                    />
                  </button>
                  <div
                    className={`grid transition-all duration-300 ease-out ${
                      isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-4 text-sm leading-relaxed text-foreground-600">
                        {faq.a}
                      </p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}